var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className},[(_vm.counter)?_c('div',{staticClass:"c-slider__counter"},[_c('span',{staticClass:"c-slider__index"},[_vm._v(_vm._s(_vm.currentIndex))]),_vm._v(" / "+_vm._s(_vm.totalSlides)+"\n    ")]):_vm._e(),_c('flickity',{ref:"flkty",staticClass:"c-slider__inner",attrs:{"options":_vm.flktyOpts}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }